

























































































































































































































































































































































































































import Vue from 'vue';
// @ts-ignore
import xss from 'xss';
import _ from 'lodash';
import moment from 'moment';
import { blackList } from '@/util/blackFair';
import { mapState } from 'vuex';
import { getContent, OSS_BUCKET_URL } from '~/util/common';
import { ResponseCode } from '~/util/constant';
import { $cookies } from '~/util/api';
import 'swiper/css/swiper.min.css';
import 'vue-photo-preview/dist/skin.css';

const cu = [
  { lab: '展会顾问', val: '殷先生　 陶先生' },
  { lab: '联系单位', val: '聚展（杭州）网络科技有限公司' },
  { lab: '联系地址', val: '杭州市余杭区仓兴街1号37幢209' },
];
const cu1 = [
  { lab: '联系邮箱', val: '379516172@qq.com' },
  { lab: '联系电话', val: '0571-86376515   13336109418' },
];
const ser = [
  { img: 's1', tit: '如实描述', sub: '全球专业展会如实描述' },
  { img: 's2', tit: '安全交易', sub: '交易安全可靠有保障' },
  { img: 's3', tit: '安心服务', sub: '1对1专业展会顾问服务' },
  { img: 's4', tit: '一手资源', sub: '总代，一手资源丰富' },
  { img: 's5', tit: '行程定制', sub: '参观展行程按需定制' },
];
const bank1 = [
  { lab: '公司名称', val: '聚展（杭州）网络有限公司' },
  { lab: '开户行', val: '杭州银行海创园支行' },
  { lab: '银行账号', val: '3301040160009522429' },
];
const bank2 = [
  { lab: '公司名称', val: '浙江天玺展览有限公司' },
  { lab: '开户行', val: '中国银行杭州城西科创支行' },
  { lab: '银行账号', val: '379281941817' },
];
export default Vue.extend({
  layout: 'layout3',
  components: {},
  filters: {
    dateFormat2(date: string) {
      return moment(new Date(date)).format('YYYY年MM月DD日');
    },
    newDateFormat(data: Record<string, any>) {
      if (data.startTime && data.endTime) {
        const startTime = moment(data.startTime).format('YYYY.MM.DD');
        const endTime = moment(data.endTime).format('MM.DD');
        return `${startTime}-${endTime}`;
      } else {
        return '时间待定';
      }
    },
    industry(data: string): string {
      try {
        return data.split(',')[0] + '展会';
      } catch (error) {
        if (process.client && 'fundebug' in window) {
          window.fundebug.notifyError(error);
        }
        return data + '展会';
      }
    },
    logo(value: string): string {
      let parse: any = value;
      if (typeof value === 'string') {
        try {
          parse = JSON.parse(value)[0].replace('http://', 'https://');
          // .replace(bucketHost, bucketCdnHost);
        } catch (error) {
          parse = value;
          console.error(error);
        }
      }
      return parse + `?${Date.now()}`;
    },
  },
  async asyncData(ctx) {
    const lang = _.get(ctx, 'query.lang', null);
    let langApi = 'cn';
    if (lang == 'zh') langApi = 'cn';
    if (lang == 'en') langApi = 'en';
    let id = _.get(ctx, 'params.id', null);
    if (!id) {
      const reg = /\/exhibition\/(\d+)\.html/;
      const result = ctx.route.path.match(reg);
      if (result) {
        id = result[1];
      }
    }

    const res: any[] = await Promise.all([
      ctx.$axios.get(`/api/exhibition/${id}`),
      ctx.$axios.post(`/api/exhibition/list`, {
        locale: langApi,
        selectTimeType: 1,
        exhibitionId: id,
        exhibitionType: 'CURRENT', // 同期展会
        pageNum: 1,
        pageSize: 30,
      }),
      ctx.$axios.post(`/api/exhibition/list`, {
        locale: langApi,
        selectTimeType: 1,
        exhibitionId: id,
        exhibitionType: 'SERIES', // 系列展会
        pageNum: 1,
        pageSize: 30,
      }),
      ctx.$axios.get(`/api/exhibition/boothInfo/${id}`),
      ctx.$axios.get(`/api/ticket/query/${id}`),
    ]);

    const [detailRes, sameFairRes, logoFairRes, boothRes, ticketRes] = res;

    let detail: Record<string, any> = {};
    const industry: any[] = [];
    let industryId: any[] = [];
    let industryName: any[] = [];
    let isFocus = false; // 是否关注
    let remind = false; // 是否提醒
    if (detailRes.code === ResponseCode.SUCCESS) {
      detail = detailRes.data || {};
      if (detail.pavilionInfo) {
        detail.pavilionInfo.picture = detail.pavilionInfo?.picture.split(';');
      }
      if (
        (!_.isNil(detail.online) && detail.online !== 1 && id !== '4') ||
        _.isNil(detailRes.data)
      ) {
        return ctx.error({
          message: 'Page not found',
          path: ctx.route.fullPath,
          statusCode: 404,
        });
      }
      industryId = [
        detail.industry1,
        detail.industry2,
        detail.industry3,
      ].filter((id) => !!id);
      industryName = detail.industry?.split(',') || [];
      industryName.forEach((name, index) => {
        industry.push({
          id: industryId[index],
          name,
        });
      });
      isFocus = detailRes.data?.isFocus === 1; // 1: 已关注 0: 未关注
      remind = detailRes.data.follow; // 1: 提醒 0: 未提醒
    } else {
      return ctx.error({
        message: 'Page not found',
        path: ctx.route.fullPath,
        statusCode: 404,
      });
    }

    // 同期展会
    let sameFair = {};
    if (sameFairRes.code === ResponseCode.SUCCESS) {
      sameFair = sameFairRes.data;
    }

    // 系列展会
    let logoFair = {};
    if (logoFairRes.code === ResponseCode.SUCCESS) {
      logoFair = logoFairRes.data;
    }
    // 展会价格
    let booth = {};
    if (boothRes.code === ResponseCode.SUCCESS) {
      booth = boothRes.data;
    }

    const otherRes: any[] = await Promise.all([
      ctx.$axios.post('/api/exhibition/list', {
        locale: langApi,
        selectTimeType: 1,
        industryId: _.get(industry, '[0].id', null), // 行业展会
        regionType: detail.regionType,
        pageNum: 1,
        pageSize: 8,
      }),
      ctx.$axios.post('/api/newsApi/homePageList', {
        industryId: _.get(industry, '[0].id', null), // 推荐资讯
        newsType: 1,
        pageNum: 1,
        pageSize: 8,
      }),
      ctx.$axios.post('/api/newsApi/homePageList', {
        // 最新资讯
        newsType: 1,
        pageNum: 1,
        pageSize: 8,
      }),
      ctx.$axios.post('/api/exhibition/page', {
        // 最新展会
        locale: langApi,
        pageNum: 1,
        pageSize: 8,
      }),
    ]);

    const [industryFairRes, newsRes, newNewsRes, newFairRes] = otherRes;

    // 行业展会
    let industryFair = {};
    if (industryFairRes.code === ResponseCode.SUCCESS) {
      industryFair = industryFairRes.data;
    }

    // 行业资讯
    let news = {};
    if (newsRes.code === ResponseCode.SUCCESS && newsRes.data && newsRes.data.records) {
      news = newsRes.data.records.map(
        (item: { newsId: any; newsName: any; views: any }) => ({
          newsId: item.newsId,
          newsName: item.newsName,
          views: item.views,
        })
      );
    }

    // 最新资讯
    let newNews = {};
    if (newNewsRes.code === ResponseCode.SUCCESS && newNewsRes.data && newNewsRes.data.records) {
      newNews = newNewsRes.data.records.map(
        (item: { newsId: any; newsName: any; views: any }) => ({
          newsId: item.newsId,
          newsName: item.newsName,
          views: item.views,
        })
      );
    }

    // 最新展会
    let newFair = {};
    if (newFairRes.code === ResponseCode.SUCCESS) {
      newFair = newFairRes.data.records.map(
        (item: { exhibitionId: any; exhibitionName: any; views: any }) => ({
          exhibitionId: item.exhibitionId,
          exhibitionName: item.exhibitionName,
        })
      );
    }
    let ticketPrice = {};
    if (ticketRes.code === ResponseCode.SUCCESS) {
      ticketPrice = ticketRes.data;
    }

    return {
      detail,
      industry,
      isFocus,
      remind,
      sameFair,
      logoFair,
      booth,
      industryFair,
      news,
      newNews,
      newFair,
      ticketPrice,
      attribution: `&copy; <span>${
        _.get(detail, 'pavilionInfo.pavilionName', null) ||
        _.get(detail, 'pavilionInfo.pavilionEnglishName', null)
      }</span>`,
      center: [
        _.get(detail, 'pavilionInfo.latitude', 0),
        _.get(detail, 'pavilionInfo.longitude', 0),
      ],
    };
  },
  data(): any {
    return {
      cu,
      cu1,
      ser,
      bank: [],
      companyName: '聚展（杭州）网络有限公司',
      player: '',
      isLoading: true,
      videoVisible: false,
      OSS_BUCKET_URL,
      blackList,
      detail: {},
      activeName: 'first',
      showTitle: true,
      switchValue: true,
      fraction: 3.7,
      current: '展会数据',
      showEvaluation: false, // 控制评价弹框
      showMore: false,
      sameSwiperOption: {
        slidesPerView: 4,
        spaceBetween: 10,
        autoplay: 3000, // l轮播间隔时间
        loop: false, //
        lazy: {
          // 懒加载
          loadPrevNext: true,
          loadPrevNextAmount: 2,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOption: {
        slidesPerView: 3.2,
        spaceBetween: 10,
        autoplay: 3000, // l轮播间隔时间
        loop: false, // 是否自动轮播
      },
      serviceList: [],
    };
  },
  computed: {
    ...mapState({
      isLogin: (state: any) => state.global.isLogin,
    }),
    photos(): any[] {
      try {
        const newArr: any[] = [];
        if (this.detail.photos) {
          this.detail.photos.slice(1).map((item: { resourceUrl: any }) => {
            newArr.push(item.resourceUrl);
          });
        }
        return newArr;
      } catch (error) {
        if (process.client && 'fundebug' in window) {
          window.fundebug.notifyError(error);
        }
        return this.detail.pic;
      }
    },
    industryList(): string[] {
      if (this.detail.industry) {
        try {
          const industry = this.detail.industry?.split(',');
          return industry;
        } catch (error) {
          return [];
        }
      }
      return [];
    },
    tips(): any[] {
      try {
        const { tips } = this.$data.ticketPrice;
        return JSON.parse(tips).slice(0, 2);
      } catch (error) {
        return [];
      }
    },
  },
  created(): void {
    this.bank = this.getBank();
    this.companyName = this.getCompanyName();
  },
  mounted(): void {
    // setTimeout(() => {
    //   this.exportPDF('detail-container');
    // }, 3000);
    // console.log(this.exportPDF);
    window.addEventListener('message', async (e: any) => {
      // console.log(e.data);
    //   if (e.data.message === 'exportPDF') {
    //     await this.exportPDF('detail-container');
    //     window.parent.postMessage({ message: 'pdf:ok' }, '*');
    //   }
    });
  },
  beforeDestroy() {},
  methods: {
    unescape,
    xss,
    getContent,
    moment,
    separator(numb: string) {
      const str = numb.toString().split('.');
      str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return str.join('.');
    },
    shouldLogin() {
      const access_token = $cookies.get('access_token');
      // 获取不到token为未登录, 前往登录页
      if (!access_token) {
        this.$login.show();
        // this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`);
      }
      return !!access_token;
    },
    getBank() {
      if (process.client) {
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.get('type')) {
          return bank2;
        }
      }
      return bank1;
    },
    getCompanyName() {
      if (process.client) {
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.get('type')) {
          this.cu[1].val = '浙江天玺展览有限公司';
          return '浙江天玺展览有限公司';
        }
      }
      this.cu[1].val = '聚展（杭州）网络有限公司';
      return '聚展（杭州）网络有限公司';
    },
    // 控制进度条不显示百分比
    format() {
      return '';
    },
  },
  head(): Record<string, any> {
    const {
      lunchTime,
      exhibitionName,
      exhibitionEnglishName,
      pavilionInfo,
      organizer,
      pic,
      industry = '',
    } = this.$data.detail;
    const { areaName, pavilionAddress } = pavilionInfo || {};
    const _year = lunchTime?.slice(0, 4);

    const _keyword = [];
    const nameEn = exhibitionEnglishName?.trim() || '';
    try {
      _keyword.push(nameEn);
      const industryList = industry?.split(',') || [];
      industryList.forEach((name: string) => {
        _keyword.push(`${areaName}${name}展`);
        _keyword.push(`${areaName}${name}展时间`);
        _keyword.push(`${areaName}${name}展门票`);
        _keyword.push(`${areaName}${name}展展位图`);
        _keyword.push(`${areaName}${name}展价格`);
      });
    } catch (error) {
      console.error(error);
    }
    const keywords = _keyword.join(',');
    let cover = require('~/assets/logo/logo.png');
    try {
      cover = JSON.parse(pic)[0];
    } catch (error) {
      if (process.client && 'fundebug' in window) {
        window.fundebug.notifyError(error);
      }
      console.error(error);
      cover = require('~/assets/logo/logo.png');
    }
    // const titleName = nameEn?.length >= 20 ? '' : `_${nameEn}`;
    const title = `${exhibitionName}${_year}_门票_价格_会刊-聚展`;
    const description = `展会时间:${lunchTime},展会地点:${pavilionAddress},主办方:${organizer},聚展网提供展会门票和展位预订服务.`;
    const aliplayer =
      'https://g.alicdn.com/de/prismplayer/2.9.3/skins/default/aliplayer-min.css';
    return {
      title,
      meta: [
        {
          name: 'robots',
          content: 'noindex,nofollow',
        },
        {
          name: 'keywords',
          content: keywords,
        },
        {
          name: 'description',
          content: description,
        },
        {
          name: 'og:type',
          content: 'product',
        },
        {
          name: 'og:image',
          content: cover,
        },
        {
          name: 'og:title',
          content: title,
        },
        {
          name: 'og:description',
          content: description,
        },
        {
          name: 'og:url',
          content: `//www.madkapital.com${this.$route.path}`,
        },
        {
          name: 'og:product:price',
          content: this.booth?.boothPrice1,
        },
        {
          name: 'og:product:category',
          content: `${industry}展会`,
        },
        {
          name: 'og:product:nick',
          content: `name=聚展网; url=//www.madkapital.com${this.$route.path}`,
        },
      ],
      link: [
        {
          rel: 'stylesheet',
          href: aliplayer,
        },
      ],
      script: [
        {
          charset: 'utf-8',
          type: 'text/javascript',
          src: 'https://g.alicdn.com/de/prismplayer/2.9.3/aliplayer-min.js',
          rel: 'prefetch',
        },
      ],
    };
  },
});
